// @flow
import moment from 'moment'
import type {Action} from 'lib/definitions/redux'
import type {AuthToken} from 'lib/definitions/identity'
import Immutable from 'seamless-immutable'
import {REHYDRATE} from 'redux-persist/constants'
import {APP_RESET_STATE} from '../actions/app'
import * as authActions from '../actions/auth'
import {validateLoginForm} from '../../lib/form/formValidation'
import Config from '../../lib/config'

// todo: make these field names consts for the action?

export type Route = {
	name: string,
	meta: Object
}

export type AuthState = Immutable<{
	username: string,
	rememberMe: boolean,
	pinEnabled: boolean,
	fingerprintSecret: boolean,
	isPosting: boolean,
	loginErrorMessage: ?string,
	usernameErrorMessage: ?string,
	passwordErrorMessage: ?string,
	token: ?AuthToken,
	isLocked: boolean,
	firstLogin: boolean,
	captcha: ?string,
	disabled: boolean,
	afterLoginRoute: ?Route,
	loadedFromPersist: boolean
}>


const initialState : AuthState = Immutable({
	username: typeof(__DEV__) !== 'undefined' && Config.TEST_CREDENTIALS ? Config.TEST_CREDENTIALS.username : '',
	rememberMe: false,
	pinEnabled: false,
	fingerprintSecret: false,
	isPosting: false,
	loginErrorMessage: undefined,
	usernameErrorMessage: undefined,
	passwordErrorMessage: undefined,
	token: undefined,
	isLocked: false,
	firstLogin: true,
	captcha: undefined,
	disabled: false,
	afterLoginRoute: undefined,
	loadedFromPersist: false
})


function clearErrorMessage(state : AuthState, field : 'username' | 'password'){
	switch(field){
		case 'username':
			return state.set('usernameErrorMessage', undefined)
		case 'password':
			return state.set('passwordErrorMessage', undefined)
	}

	return state
}

export default function (state : AuthState = initialState, action : Action){
	switch(action.type){
		case APP_RESET_STATE:
		case REHYDRATE:
			let auth = action.payload.Auth
			if(auth){
				auth = Immutable.asMutable(action.payload.Auth)
				if(!auth.rememberMe){
					auth.username = ''
				}

				if(auth.token && (action.type == APP_RESET_STATE || (moment.utc().format('X') >= auth.token.exp))){
					auth.token = undefined
				}

				return state.merge({
					username: auth.username,
					rememberMe: auth.rememberMe,
					pinEnabled: auth.pinEnabled === undefined ? false : auth.pinEnabled,
					fingerprintSecret: auth.fingerprintSecret === undefined ? false : auth.fingerprintSecret,
					firstLogin: auth.firstLogin === undefined ? true : auth.firstLogin,
					token: auth.token,
					loadedFromPersist: true
				})
			}

			return state.set("loadedFromPersist", true)

		case authActions.AUTH_FORM_FIELD_CHANGE:
			return clearErrorMessage(state, action.data.field)
				.merge({loginErrorMessage: undefined, [action.data.field]: action.data.value})

		case authActions.LOGIN_REQUEST:
			return state.merge({action: action.type, isPosting: true, loginErrorMessage: undefined})

		case authActions.VALIDATE_LOGIN_FORM:
			return state.merge(validateLoginForm(state, action))

		case authActions.LOGIN_SUCCESS:
			return state.merge({token: action.token, isPosting: false, isLocked: false})

		case authActions.LOGIN_FAILURE:
			if(action.error === authActions.LOGIN_MUST_RESET_PASS_ERROR_CODE){
				state = state.merge({
					password: ''
				})
			}

			return state.merge({isPosting: false, loginErrorMessage: action.error})

		case authActions.CLEAR_PASSWORD_ERROR_MESSAGE:
			return clearErrorMessage(state, action.field)

		case authActions.LOGIN_LOCK:
			return state.merge({isLocked: true, token: undefined})

		case authActions.LOGIN_SET_TOKEN:
			return state.set('token', action.token)

		case authActions.LOGIN_REMOVE_PIN:
			return state.set('pinEnabled', false)

		case authActions.LOGIN_ENABLE_PIN:
			return state.merge({
				pinEnabled: true,
				rememberMe: true
			})

		case authActions.LOGIN_REMOVE_FINGERPRINT:
			return state.set('fingerprintSecret', false)

		case authActions.LOGIN_ENABLE_FINGERPRINT:
			return state.merge({
				rememberMe: true,
				fingerprintSecret: action.secret
			})

		case authActions.LOGIN_CLEAR_FIRST_LOGIN:
			return state.set('firstLogin', false)

		case authActions.LOGIN_SET_CAPTCHA:
			return state.set('captcha', action.captcha)

		case authActions.LOGIN_PREVENT_OLD_VERSION:
			return state.set('disabled', true)

		case authActions.LOGIN_SET_AFTER_LOGIN_ROUTE:
			return state.set('afterLoginRoute', action.route)
	}

	return state
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/reducers/auth.js